import { Stack } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import SponaLogo from '../../../assets/img/logo/spona-black.svg';
import CustomButton from '../../../components/button/CustomButton';
import CustomLink from '../../../components/link/Link';
import RightSideToolbar from '../../dashboard-navigation/appbar/RightSideToolbar';
import { LAYOUT_DEFAULTS } from '../../../utils/constants';
import useAuth from '../../../utils/hooks/useAuth';

export const PUBLIC_APPBAR_HEIGHT = 77;
// on screens greater than or equal to 1920 (xxl), we want the navigation
// and footer to be wider than the rest of the content
const CUSTOM_LAYOUT_DEFAULTS = { mx: { ...LAYOUT_DEFAULTS.mx, xxl: 10 } };

const LargeNavLoginAndSignupButtons = () => {
  const {
    authData: { accessToken },
  } = useAuth();
  const hasUser = accessToken !== null;

  return hasUser ? (
    <RightSideToolbar />
  ) : (
    <Stack direction="row" spacing={2}>
      <CustomButton variant="secondary" href="/login">
        Log in
      </CustomButton>

      <CustomButton href="/register">Sign up</CustomButton>
    </Stack>
  );
};

const Navigation = () => (
  <Stack>
    <AppBar
      color="inherit"
      sx={{
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        height: PUBLIC_APPBAR_HEIGHT,
        position: 'fixed',
        boxShadow: '1px 10px 30px 0px rgba(56, 69, 114, 0.10)',
        zIndex: 1000001,
      }}
    >
      <Toolbar
        disableGutters
        sx={{
          py: { xs: 1, sm: 2, lg: 2 },
          ...CUSTOM_LAYOUT_DEFAULTS,
        }}
      >
        <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%">
          <CustomLink to="/">
            <Box src={SponaLogo} sx={{ mr: { xs: 0, lg: 5 } }} component="img" />
          </CustomLink>

          <LargeNavLoginAndSignupButtons />
        </Stack>
      </Toolbar>
    </AppBar>
  </Stack>
);

export default Navigation;
